import { t } from 'i18next';

export class Money {
  static readonly precision = 2;
  static validateRx = /^-?\d+(\.\d+)?$/;

  static ZERO = new Money(0);

  constructor(public value: number) {}

  static parse(s: string): Money {
    if (!this.validateRx.test(s)) throw new Error('Invalid money format');

    const values = s.split('.');

    let coins = 0;

    switch (values.length) {
      case 1:
        coins = Number.parseInt(values[0] + '0'.repeat(Money.precision));
        break;
      case 2:
        let right = values[1].slice(0, Money.precision);
        right = right + '0'.repeat(Money.precision - right.length);
        coins = Number.parseInt(values[0] + right);
        break;
    }
    return new Money(coins);
  }

  plus(other: Money) {
    return new Money(this.value + other.value);
  }

  minus(other: Money) {
    return new Money(this.value - other.value);
  }

  toString() {
    let s = this.value.toString();
    while (s.length < 3) s = '0' + s;
    return s.slice(0, s.length - Money.precision) + '.' + s.slice(s.length - Money.precision, s.length);
  }

  toLocaleString() {
    return this.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ').replace('.00', '') + ` ${t("currency")}`;
  }

  getMain() {
    return parseInt(this.toString())
  }

  getFractional() {
    return this.toString().split('.')[1]
  }

  lessThan(other: Money): boolean {
    return this.value < other.value
  }

  lessThanOrEqual(other: Money): boolean {
    return this.value <= other.value
  }

  greaterThan(other: Money): boolean {
    return this.value > other.value
  }

  greaterThanOrEqual(other: Money): boolean {
    return this.value >= other.value
  }
}
